/** The deck readout: RPM, pitch and the level meter. */

import type { Component } from 'solid-js';
import { clamp } from '../../lib/math.ts';
import { level, pitch, rpm } from '../../state/player.ts';
import { Glass } from '../primitives/Glass.tsx';
import styles from './Readout.module.css';

const speed = (): string => (rpm() === 45 ? '45' : '33⅓');
const pitchLabel = (): string => `${pitch() >= 0 ? '+' : ''}${pitch().toFixed(1)}%`;

export const Readout: Component = () => (
  <Glass class={styles.readout}>
    <div class={styles.row}>
      <span class={styles.key}>RPM</span>
      <span class={styles.value} data-testid="readout-rpm">
        {speed()}
      </span>
    </div>
    <div class={styles.row}>
      <span class={styles.key}>PITCH</span>
      <span class={styles.value} data-testid="readout-pitch">
        {pitchLabel()}
      </span>
    </div>
    <div class={styles.meter}>
      <div
        class={styles.meterFill}
        data-testid="readout-level"
        style={{ width: `${clamp(level(), 0, 1) * 100}%` }}
      />
    </div>
  </Glass>
);
